import Modal from '@/Components/Modal';
import IconError from '@/Icons/IconError.jsx';
import PrimaryButton from '@/Components/PrimaryButton';

export default function ErrorModal({ show, onClose, message = 'Došlo je do greške.' }) {
    return (
        <Modal show={show} onClose={onClose} className="max-w-md w-full text-center relative p-8">
            <div className="p-6">
                <IconError className="mx-auto mb-6" width="64" />

                <h2 className="text-lg font-semibold text-red-600 mb-2">
                    Greška
                </h2>

                <p className="text-gray-600 mb-6">
                    {message}
                </p>

                <PrimaryButton onClick={onClose}>Zatvori</PrimaryButton>
            </div>
        </Modal>
    );
}
